import gql from 'graphql-tag';

const CREATE_LOCATION_WITH_GEOTARGET = gql`
  # TODO: Enhance payload handling for this mutation
  # @params: data: LocationCreateInput!
  mutation createLocation(
    $name: String!
    $description: String!
    $street: String!
    $city: String!
    $state: StateType
    $lat: Float!
    $lng: Float!
    $country: CountryType!
    $email: String!
    $url: String!
    $phone: String!
    $contact: String!
    $formattedAddress: String!
    $zip: String!
    $orgId: ID!
    $cart: CartProvider
    $menuDataKey: String
    $geoId: ID
    $locationKey: String
    $audienceType: AudienceType
    $province: String
    $createdBy: ID
  ) {
    createLocation(
      data: {
        name: $name
        description: $description
        street: $street
        city: $city
        state: $state
        lat: $lat
        lng: $lng
        country: $country
        email: $email
        url: $url
        phone: $phone
        contact: $contact
        formattedAddress: $formattedAddress
        zip: $zip
        org: { connect: { id: $orgId } }
        transConfig: { create: { cart: $cart, menuDataKey: $menuDataKey } }
        geoframe: { connect: { id: $geoId } }
        locationKey: $locationKey
        audienceType: $audienceType
        province: $province
        createdBy: { connect: { id: $createdBy } }
      }
    ) {
      id
      name
      description
      street
      city
      state
      province
      country
      lat
      lng
      formattedAddress
      email
      phone
      contact
      url
      locationKey
      zip
      catalogs(first: 5) {
        id
      }
      hours
      createdAt
      org {
        id
        name
      }
      geoframe {
        id
        name
        start
        end
        polygons {
          id
          geometry
        }
        circles {
          id
          coordinate {
            lat
            lng
          }
          radius
        }
      }
      transConfig {
        id
        cart
        menuDataKey
      }
      audienceType
      createdBy {
        id
        name
      }
    }
  }
`;

export default CREATE_LOCATION_WITH_GEOTARGET;
